import angular from 'angular';
import autoScrollTo from './autoScrollTo.directive';
import compile from './compile.directive';
import parse from './parse.directive';
import resize from './resize.directive';
import phoneInputField from './phoneInputField.directive';


let directivesModule = angular.module('directives', [])
.directive({
  autoScrollTo,
  compile,
  parse,
  resize,
  phoneInputField
})
.name;

export default directivesModule;



// WEBPACK FOOTER //
// ./client/app/common/directives/directives.js